module.exports = __webpack_public_path__ + "static/media/arrow-left.c62893f0.svg";